import { useMutation } from "@tanstack/react-query";

import { addUserLabelAction } from "@/actions/user/addUserLabelAction";
import { registerUserAction } from "@/actions/user/registerUserAction";
import { sendVoyadoEmailRegistrationEvent } from "@/utils/voyadoTracking";
import useTracking from "@features/tracking/hooks/useTracking";

export function useCreateVoyadoContact({ label }: { label?: string }) {
  const { emailRegistration } = useTracking();
  return useMutation({
    mutationFn: registerUserAction,
    mutationKey: ["voyadoContact"],
    onSuccess: (data) => {
      console.log("Voyado contact created successfully:", data);

      sendVoyadoEmailRegistrationEvent(data.attributes.email);
      emailRegistration(data.attributes.email);
    },
    onError: (error) => {
      console.error("Error creating Voyado contact:", error);
    },
    onSettled: async (data, _, variables) => {
      if (!label) {
        console.warn("Label is not defined. Skipping createLabelForUser.");
        return;
      }

      const email = data?.attributes?.email ?? variables.contact.email;

      return addUserLabelAction({
        locale: variables.locale,
        email,
        label,
      })
        .then((response) => {
          if (!response) {
            console.error(
              `Could not create label ${label} for user ${email}`,
              response,
            );
            return;
          }

          console.log(`Successfully created label ${label} for email ${email}`);
        })
        .catch((error) => {
          console.error(
            `Error creating label ${label} for user ${email}:`,
            error,
          );
        });
    },
  });
}
